import type {NotificationsActions} from 'src/action-creators/notifications';
import type {NotificationAPIResponse} from 'src/components/notifications/types';
import {
  RECEIVE_NOTIFICATIONS,
  SET_BADGE,
  ADD_NEW_UNREAD_NOTIFICATION,
  NUDGE_NOTIFICATION_READ,
  REMOVE_NOTIFICATION_FROM_LIST,
  RECEIVE_NOTIFICATION_FILTERS,
} from 'src/action-creators/notifications';


export type NotificationsState = {
  showBadge: boolean;
  notifications: NotificationAPIResponse;
  filters: string[];
};

const initialState: NotificationsState = {
  showBadge: false,
  notifications: {
    items: [],
    nextCursor: '',
    hasMore: false,
  },
  filters: [],
};

export default function notificationsReducer(
  state: NotificationsState = initialState,
  action: NotificationsActions,
): NotificationsState {
  switch (action.type) {
    case RECEIVE_NOTIFICATION_FILTERS:
      return {
        ...state,
        filters: action.payload,
      };
    case REMOVE_NOTIFICATION_FROM_LIST:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          items: state.notifications.items.filter(
            (item) => item.id !== action.payload,
          ),
        },
      };
    case SET_BADGE:
      return {
        ...state,
        showBadge: action.payload,
      };
    case NUDGE_NOTIFICATION_READ:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          items: state.notifications.items.map((item) =>
            item.id === action.payload.notificationId
              ? {...item, readAt: action.payload.readAt}
              : item,
          ),
        },
      };
    case ADD_NEW_UNREAD_NOTIFICATION:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          items: [action.payload, ...state.notifications.items],
        },
        filters: state.filters.includes(action.payload.source)
          ? state.filters
          : [...state.filters, action.payload.source],
        showBadge: true,
      };
    case RECEIVE_NOTIFICATIONS:
      return {
        ...state,
        notifications: {
          ...state.notifications,
          items: action.payload.appendData
            ? [...state.notifications.items, ...action.payload.items]
            : action.payload.items,
          nextCursor: action.payload.nextCursor,
          hasMore: action.payload.hasMore,
        },
      };
    default:
      return state;
  }
}
